"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/auth-provider";
import { useEffect, useRef } from "react";
import { useSectionScroll } from "@/components/home/section-scroll";
import { ProjectExplorer } from "@/components/home/project-explorer";
import { Icon } from "@/components/icons/interface";
import { AtlasIconLogo } from "@/components/icons/logo";
export default function Home() {
  const $ = _c(35);
  const {
    user,
    openAuth
  } = useAuth();
  const page = useRef(null);
  useSectionScroll(page);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const root = page.current;
      if (!root || !window.IntersectionObserver || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).dataset.seen = "true";
            observer.unobserve(entry.target);
          }
        }
      }, {
        threshold: 0.12
      });
      root.querySelectorAll("[data-section]").forEach(section => {
        section.dataset.revealReady = "true";
        observer.observe(section);
      });
      const revealFocus = event => {
        const section_0 = (event.target as HTMLElement).closest("[data-section]");
        if (section_0) {
          section_0.dataset.seen = "true";
          observer.unobserve(section_0);
        }
      };
      root.addEventListener("focusin", revealFocus);
      return () => {
        observer.disconnect();
        root.removeEventListener("focusin", revealFocus);
        root.querySelectorAll("[data-section]").forEach(_temp);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="atlas-eyebrow" data-reveal={true}>The development engine</p>;
    t3 = <h1><span data-reveal="1">Build software.</span><span data-reveal="2">See the whole picture.</span></h1>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="atlas-hero-description" data-reveal="3">The creative freedom of a game engine, for software.<br className="atlas-desktop-break" /> Connect nodes. Create your own types. Build reusable packages.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== openAuth || $[6] !== user) {
    t5 = user ? <a className="atlas-button atlas-button-primary" href="/platform/">Open workspace <Icon name="arrow" /></a> : <button className="atlas-button atlas-button-primary" data-overlay-target={true} onClick={() => openAuth("signup")}>Get started <Icon name="arrow" /></button>;
    $[5] = openAuth;
    $[6] = user;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <a className="atlas-button atlas-button-secondary" href="#explore">Explore the editor</a>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="atlas-hero-actions" data-reveal="3">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="atlas-alpha" data-reveal="4">Early alpha · Actively evolving</p>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <section className="atlas-hero atlas-container atlas-page-section" data-section={true}>{t2}{t3}{t4}{t7}{t8}</section>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ProjectExplorer />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="atlas-eyebrow" data-reveal={true}>Packages</p>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="atlas-foundation-heading">{t11}<h2 data-reveal="1">Make it once.<br />Build on it anywhere.</h2><p data-reveal="2">Turn your types and graphs into a library. Use it in another project through the inputs and outputs it exposes.</p><p data-reveal="3">Graphics, files, or something entirely your own. Packages define the functionality.</p></div>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="atlas-panel-caption"><Icon name="package" /><span>One way to compose</span></div>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ul className="atlas-shared-resources"><li><Icon name="graph" /><div><strong>Core</strong><p>Types, values, loops, and error handling. The starting point in every project.</p></div></li><li><Icon name="layers" /><div><strong>Your libraries</strong><p>Custom nodes use the same editor. Their implementation stays inside the package.</p></div></li></ul>;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <section className="atlas-container atlas-foundation atlas-page-section" id="packages" data-section={true}>{t12}<div className="atlas-package-panel" data-reveal-surface={true}>{t13}{t14}<div className="atlas-package-destination"><Icon name="folder" /><span>Exact versions, reusable across projects</span></div></div></section>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="atlas-eyebrow" data-reveal={true}>Designed for portability</p>;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="atlas-execution-heading"><div>{t16}<h2 data-reveal="1">Build once.<br />Deploy anywhere.</h2></div><p data-reveal="2">Atlas compiles your graphs into a portable program. Run it with a compatible runtime. Native application compilation is the next step.</p></div>;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <section className="atlas-container atlas-execution atlas-page-section" id="execution" data-section={true}>{t17}<ol className="atlas-pipeline" data-reveal="2"><li><span><Icon name="graph" />Compose</span><p>Organize instances. Connect behavior in graphs.</p></li><li><span><Icon name="package" />Bundle</span><p>Export a project with its exact package dependencies.</p></li><li><span><Icon name="code" />Compile</span><p>Keep the code your program uses. Leave unused Atlas code out.</p></li><li><span><Icon name="play" />Run</span><p>Execute on a compatible target with the required package bindings.</p></li></ol></section>;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div><h2 data-reveal="1">What will you build?</h2><p>Your next project starts here.</p></div>;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== openAuth || $[25] !== user) {
    t20 = <div className="atlas-container atlas-start">{t19}{user ? <a className="atlas-button atlas-button-primary" href="/platform/">Open workspace <Icon name="arrow" /></a> : <button className="atlas-button atlas-button-primary" data-overlay-target={true} onClick={() => openAuth("signup")}>Create an account <Icon name="arrow" /></button>}</div>;
    $[24] = openAuth;
    $[25] = user;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  let t22;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <a href="#main" className="atlas-wordmark" aria-label="Atlas, back to top"><AtlasIconLogo /><span>atlas</span></a>;
    t22 = <span>The development engine.</span>;
    $[27] = t21;
    $[28] = t22;
  } else {
    t21 = $[27];
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <footer className="atlas-container atlas-footer">{t21}{t22}<nav aria-label="Footer"><a href="#architecture">Platform</a><a href="#packages">Packages</a><a href="#execution">Execution</a></nav></footer>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t20) {
    t24 = <section className="atlas-closing atlas-page-section" data-section={true}>{t20}{t23}</section>;
    $[30] = t20;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== t24 || $[33] !== t9) {
    t25 = <main ref={page} id="main" className="atlas-home" tabIndex={-1}>{t9}{t10}{t15}{t18}{t24}</main>;
    $[32] = t24;
    $[33] = t9;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  return t25;
}
function _temp(section_1) {
  return delete section_1.dataset.revealReady;
}